function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwPanel from 'viewmodel/AwPanelViewModel';
import AwBackButton from 'viewmodel/AwBackButtonViewModel';
import AwSearchBox from 'viewmodel/AwSearchBoxViewModel';
import AwList from 'viewmodel/AwListViewModel';
import AwDefaultCell from 'viewmodel/AwDefaultCellViewModel';
import AwPanelFooter from 'viewmodel/AwPanelFooterViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
import AwI18n from 'viewmodel/AwI18nViewModel';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/DesTeamMembersService', () => import('js/DesTeamMembersService'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/desCollabEventBus', () => import('js/desCollabEventBus'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "props": {
    "sub-panel-context": {
      "type": "object"
    },
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    }
  },
  "data": {
    "searchBox": {
      "displayName": "{{i18n.searchString}}",
      "type": "STRING",
      "dbValue": ""
    },
    "searchBoxPlaceHolder": {
      "dbValue": "{{i18n.searchString}}"
    },
    "members": []
  },
  "dataProviders": {
    "performSearchMultipleSelection": {
      "action": "getUsers",
      "response": "{{data.searchResults}}",
      "totalFound": "{{data.totalFound}}",
      "selectionModelMode": "multiple"
    }
  },
  "actions": {
    "userlistProvider": {
      "actionType": "dataProvider",
      "method": "performSearchMultipleSelection"
    },
    "getTeamMembers": {
      "actionType": "JSFunction",
      "method": "getTeamMembers",
      "inputData": {
        "vmo": "{{data}}",
        "membersToStore": "{{parameters.eventData}}"
      },
      "deps": "js/DesTeamMembersService"
    },
    "getUsers": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "additionalProperties": {
              "accsessionid": "{{props.accsessionid}}",
              "searchInput": "{{data.searchBox.dbValue}}",
              "collaborationspaceid": "{{props.collaborationspaceid}}",
              "members": "{{data.members}}"
            },
            "query": "query ListCollabSpaceMembers($listInput: ListInput) {listCollabSpaceMembers(listInput: $listInput) }",
            "variables": {
              "listInput": {
                "searchOptions": {
                  "skip": 0,
                  "limit": 10,
                  "outputProperties": ["*"]
                }
              }
            }
          }
        },
        "progressIndicatorPrefix": "catalog",
        "accsessionid": "{{props.accsessionid}}"
      },
      "outputData": {
        "searchResults": "data.data.listCollabSpaceMembers.filterObj",
        "totalFound": "data.data.listCollabSpaceMembers.totalFound"
      },
      "events": {
        "success": [{
          "name": "searchResultsSuccess",
          "condition": "searchResults.hasError === false",
          "eventData": {
            "eventName": "searchResultsSuccess",
            "eventData": "{{searchResults}}"
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "storeData": {
      "actionType": "JSFunction",
      "method": "storeData",
      "inputData": {
        "dataProvider": "{{data.dataProviders.performSearchMultipleSelection}}",
        "sharedData": "{{props.subPanelContext.sharedData}}"
      },
      "events": {
        "success": [{
          "name": "storeData.success"
        }]
      },
      "deps": "js/DesTeamMembersService"
    },
    "doSearch": {
      "actionType": "Event",
      "method": "Event",
      "inputData": {
        "events": [{
          "name": "searchInitiated",
          "condition": "data.searchBox.dbValue && data.searchBox.dbValue.length>0",
          "eventData": {
            "eventName": "searchInitiated",
            "searchInput": "{{data.searchBox.dbValue}}"
          }
        }]
      }
    },
    "backAction": {
      "actionType": "Event",
      "method": "Event",
      "inputData": {
        "events": [{
          "name": "backButtonClicked"
        }]
      }
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventName}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/desCollabEventBus"
    }
  },
  "conditions": {},
  "onEvent": [{
    "eventId": "searchInitiated",
    "action": "userlistProvider"
  }, {
    "eventId": "getAssignedTeamMembers.success",
    "action": "getTeamMembers",
    "inputArgs": {
      "eventName": "{{eventData.eventName}}",
      "eventData": "{{eventData.eventData}}"
    }
  }, {
    "eventId": "performSearchMultipleSelection.selectionChangeEvent",
    "cacheEventData": true,
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventName": "userListSelectionChangeEditTeam",
      "eventData": "{{eventData.selectedObjects}}"
    }
  }],
  "i18n": {
    "searchString": ["DesTeamMessages"],
    "addTeamMembersTitle": ["DesTeamMessages"],
    "addButton": ["DesTeamMessages"]
  },
  "_viewModelId": "DesEditTeamSubPanel",
  "_uniqueViewModelId": "DesEditTeamSubPanel",
  "ctx": {}
};

/*
<aw-panel>
    <aw-back-button title="i18n.addTeamMembersTitle" action='backAction'></aw-back-button>
    <aw-search-box prop="data.searchBox" placeholder="data.searchBoxPlaceHolder.dbValue" action="doSearch">
    </aw-search-box>
    <aw-list dataprovider="data.dataProviders.performSearchMultipleSelection">
        <aw-default-cell vmo="item"> </aw-default-cell>
    </aw-list>
    <aw-panel-footer>
        <aw-button type='button' action='actions.storeData'>
            <aw-i18n>{{i18n.addButton}}</aw-i18n>
        </aw-button>
    </aw-panel-footer>
</aw-panel>
*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement(AwPanel, {
    revealAction: actions.reveal
  }, /*#__PURE__*/React.createElement(AwBackButton, {
    title: i18n.addTeamMembersTitle,
    action: actions.backAction
  }), /*#__PURE__*/React.createElement(AwSearchBox, _extends({}, getField("data.searchBox", fields, $index, null, null), {
    placeholder: AwParseService.instance("data.searchBoxPlaceHolder.dbValue")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    action: actions.doSearch
  })), /*#__PURE__*/React.createElement(AwList, {
    dataprovider: dataProviders.performSearchMultipleSelection,
    showDropArea: null,
    dndHandler: props.viewModel.dndHandler
  }, ({
    item,
    index
  }) => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "            ", /*#__PURE__*/React.createElement(AwDefaultCell, {
      vmo: AwParseService.instance("item")({
        props,
        data,
        fields,
        dataProviders,
        ctx,
        i18n,
        actions,
        subPanelContext,
        viewPath,
        conditions,
        formProp,
        dispatch,
        selectionModels,
        editHandlers,
        chartProviders,
        ports,
        item,
        index
      })
    }));
  }), /*#__PURE__*/React.createElement(AwPanelFooter, null, /*#__PURE__*/React.createElement(AwButton, {
    type: "button",
    action: AwParseService.instance("actions.storeData")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement(AwI18n, null, AwParseService.instance("i18n.addButton")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  })))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;